import { render, staticRenderFns } from "./PortfolioResearchStatementTab.vue?vue&type=template&id=66e61c85&scoped=true&"
import script from "./PortfolioResearchStatementTab.vue?vue&type=script&lang=js&"
export * from "./PortfolioResearchStatementTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e61c85",
  null
  
)

export default component.exports